// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  corsKey: "8f675364-fa9a-478d-8e5a-158caea42c5f",
  tenantId: "497",
  corsUrl: "https://sand1-api.acmeticketing.net/v2/b2c/cors/checkout",
  captcha: "6LcFf5gUAAAAAJCGROIYJvD2BxgvqKvCSGmxDvKU",
  ga: '',
  url: ""
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
